import "../App.css";
import React from "react";

import git from "../Images/git.png";
import lnkd from "../Images/lnd.png";
import resume from "../Images/resume.png";

const Contact = () => {
  return (
    <div className="outer-connect">
      <div className="contact">
        <h1>Contact</h1>
        <div className="contactText">
          Thanks for stopping by, I’m currently looking to join a team of
          creative designers and developers. If you think we might be a good fit
          for one another,give me a <a href="tel:+919676174309">call</a>📲 or
          send me an <a href="mailto:prudhviraj5055@gmail.com">email</a> 📧.
        </div>
        <div className="contactLinks">
          <h1>Don't be a stranger👋</h1>
          <div>
            <a href="https://github.com/prudhvi0215" target="_blank">
              <img src={git} />
              Github
            </a>
            <a
              href="https://www.linkedin.com/in/prudhvi-raj-134001191/"
              target="_blank"
            >
              <img src={lnkd} />
              Linkedin
            </a>            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
